import React from 'react';
import cn from 'classnames';
import { ReactComponent as FilterIcon } from '../../../resource/FilterIcon.svg';
import styles from './TableFilterIcon.module.scss';

const TableFilterIcon = ({ filtered = false, ...props }) => {
  return (
    <div {...props} className={cn(styles.root)}>
      <FilterIcon
        className={cn(styles.icon, { [styles.filtered]: filtered })}
      />
    </div>
  );
};

export default TableFilterIcon;
